<template>
	<div>
		<el-tabs type="border-card">
			<el-tab-pane label="图文回复">
				<el-form label-width="80px" :model="so">
					<el-form-item label="状态">
						<el-radio-group v-model="so.zhuangtai" size="small">
							<el-radio-button label="">不限</el-radio-button>
							<el-radio-button label="1">启用</el-radio-button>
							<el-radio-button label="2">禁用</el-radio-button>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="关键词">
						<el-input v-model="so.guanjianci" style="width: 80%;" size="medium"></el-input>
						<el-button size="medium" @click="CSH">搜索</el-button>
					</el-form-item>
				</el-form>
				<el-divider></el-divider>
				<el-table :data="lie" style="width: 100%">
					<el-table-column label="标题(关键字)" width="880">
						<template slot-scope="shu">
							<span style="margin-left: 10px">{{ shu.row.ming }}</span>
							<el-tag type="info" effect="dark" size="mini" style="margin-left: 20px">{{ shu.row.ci }}</el-tag>
						</template>
					</el-table-column>
					<el-table-column align="right">
						<template slot="header">
							<el-button type="danger" size="mini" @click="Mianbandakai(['huifu'])">新增回复</el-button>
						</template>
						<template slot-scope="shu">
							<el-button type="primary" size="mini" @click="Mianbandakai(['huifu',shu.row])">编辑</el-button>
							<el-button size="mini" type="danger" @click="Shanchu(shu.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination layout="total,prev,pager,next,jumper" :total="zongshu" :page-size="jitiao" :current-page.sync="ye"
				 @current-change="CSH" style="margin-top: 30px;" />

			</el-tab-pane>
		</el-tabs>
		<!-- 设置文字弹框 -->
		<el-drawer title="添加回复规则" :visible.sync="mianban.huifu" direction="rtl" size="60%">
			<el-form label-width="80px" :model="mianban_shu" style="overflow-y: scroll; height: 84vh;padding-bottom: 26px;">
				<el-form-item label="回复规则名称" label-width="100px" style="margin-left: 40px;">
					<el-input style="width: 96%;margin-left: 20px;" size="medium" placeholder="请输入回复规则名称"></el-input>
				</el-form-item>
				<!-- <el-form-item label-width="100px">
					<el-checkbox v-model="checked" style="margin-left: 60px;">高级设置</el-checkbox>
				</el-form-item>
				<el-form-item label-width="100px" label="状态">
					<el-radio v-model="radio" label="1" style="margin-left: 60px;">启用</el-radio>
					<el-radio v-model="radio" label="2">禁用</el-radio>
				</el-form-item> -->
				<el-form-item label="触发关键字" label-width="100px" style="margin-left: 30px;">
					<el-input style="width: 96%; margin-left: 20px;" size="medium" placeholder="请输入触发关键字"></el-input>
				</el-form-item>
				<!--  -->
				<el-form-item label="回复内容" label-width="110px" style="margin-left: 30px;position: relative;">
					<div class="jiawenzhang">
						<div>
						
								<!-- <template slot-scope="{item}">
							    <div class="name">{{item.value}}[ID:{{item.id}}]</div>					
							  </template> -->
							
						</div>
						<div class="daoruqu" @mousemove="zhe" @mouseout="zhe2">
							<i class="img_tishi">封面图片</i>
							<el-image class="wen_img">
								<div slot="error" class="image-slot">
									<i class="el-icon-picture-outline"></i>
								</div>
							</el-image>
							<span class="wenzhanbiaoti">文章标题</span>
							<div class="zhezhao" v-show="zhezhao"></div>
							<!-- <el-link :underline="false" class="daoruwenzi" v-show="zhezhaowenzi" @click="daoruWenzhang=true"><i class="el-icon-notebook-2"></i>导入文章</el-link> -->
							<el-link :underline="false" class="daoruwenzi shanchu" v-show="zhezhaowenzi"><i class="el-icon-close"></i>删除</el-link>
						</div>
						<div v-for="(v,i) in wlie" class="jia_wen">
							<span>文章标题</span>
							  <el-image shape="square" size="small" src="http://7niu.zhiwi.cn/vrRSSOOrTD7HsrfHSm9f7cEfMtbREH.jpg" class="wen_imgs"></el-image>
						</div>
					<!-- 	<div class="tianjiawenzhan">
							<div class="tianjia" @click="Tianjia">
							<el-link :underline="false" class="tianjiawenzi" type="info"><i class="el-icon-plus" ></i>添加</el-link>	
							</div>
						</div> -->
						
					</div>
					<div class="tianjia_wen">
						<el-autocomplete v-model="mianban_shu.fuji_nicheng"  @select="Xuanzeshangji" :trigger-on-focus="false" placeholder="请输入文章名" style="width: 100%;">
							<i class="el-icon-edit el-input__icon" slot="suffix"></i>
						</el-autocomplete>
						<el-button>添加</el-button>
					</div>
				</el-form-item>
			</el-form>
			<div class="demo-drawer__footer" style="margin-left: 148px;margin-top: 8px;">
				<el-button @click="mianban.huifu = false">取 消</el-button>
				<el-button type="primary" @click="Mianban_post('huifu')">提 交</el-button>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	let that;
	export default {
		data() {
			return {
				ye: 1,
				zongshu: 0,
				jitiao: 20,
				so: {
					zhuangtai: ''
				},
				lie: [],
				mianban: {
					huifu: false
				},
				mianban_shu: {},
				checked: true,
				radio: 3,
				zhezhaowenzi: 0,
				zhezhao: 0,
				wenzhang: [{
					fenmian: '',
					biaoti: '关于',
					date: '20191016',
					caozuo: ''
				}],
				daoruWenzhang: false,
				Xuanzeshangji:'',
				wlie:[{}],
				
			}
		},
		created() {
			that = this;
			this.CSH();
		},
		methods: {
			CSH() {
				that.so.ye = that.ye;
				that.so.jitiao = that.jitiao;
				this.$post('k=huifu&c=wenzi', that.so, function(s) {
					that.lie = s.shu.lie;
					that.zongshu = Number(s.shu.zongshu);
				});
			},
			Mianbandakai(e) {
				that.mianban[e[0]] = true;
				that.mianban_shu = e[1] || {};
			},
			Mianban_post(e) {
				if (e == 'huifu') {
					that.mianban_shu.leixing = "wenzi";
					this.$post('k=huifu&c=xiugai', that.mianban_shu, function(s) {
						that.$xiaoxi(s.shu);
						if (s.shi == 1) {
							that.CSH();
							that.mianban[e] = false;
						}
					});
				}

			},
			Shanchu(e) {
				this.$post('k=huifu&c=shandiao', {
					id: e.id
				}, function(s) {
					that.$xiaoxi(s.shu);
					if (s.shi == 1) {
						that.CSH();
					}
				});
			},
			zhe() {
				this.zhezhaowenzi = 1;
				this.zhezhao = 1;
			},
			zhe2() {
				this.zhezhaowenzi = 0;
				this.zhezhao = 0;
			},
			Tianjia(){}
		}
	}
</script>

<style scoped>
	.jiawenzhang {
		width: 290px;
		/* height: 538px; */
		padding: 15px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		margin-left: 20px;
		overflow-y: scroll; height: 60vh;
		position: absolute;
		top: 10px;
		left: 0px;
	}

	.daoruqu {
		overflow: hidden;
		width: 100%;
		height: 25%;
		position: relative;
		background: #ececec;
		margin-top: 6px;
	}

	.wen_img {
		width: 100%;
		height: 100%;
	}

	.img_tishi {
		position: absolute;
		top: 35px;
		left: 50%;
		margin-left: -35px;
		z-index: 22;
		font-size: 16px;
		color: #c0c0c0;
	}

	.wenzhanbiaoti {
		display: block;
		position: absolute;
		bottom: 0;
		left: 0;
		height: 20px;
		line-height: 20px;
		width: 100%;
		background: rgba(0, 0, 0, 0.7);
		color: #fff;
		text-align: center;
		padding: 0 10px;
		z-index: 25;
	}

	.zhezhao {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(188, 188, 188, 0.4);
		z-index: 100;
	}

	.daoruwenzi {
		left: 50%;
		z-index: 120;
		position: absolute;
		margin-left: -78px;
		top: 42px;
	}

	.shanchu {
		margin-left: -28px;
	}

	.el-icon-picture-outline {
		font-size: 28px;
	}

	.el-dialog__body {
		padding: 0px 20px;
	}
	.tianjiawenzhan{
		width:98%;
		height:74px;
		margin-top: 6px;
		/* border: 1px solid #f3f3f3; */
	}
	.tianjia{
		width: 100%;
		height: 100%;
		border: 3px dashed #f3f3f3;
		position: relative;
		cursor:pointer;
	}
	.tianjiawenzi{
		position: absolute;
		top: 15px;
		left: 50%;
		margin-left: -24px;
		font-size: 16px;
	}
	.el-icon-plus{
		font-weight: bold;
		margin-right: 10px;
	}
	.jia_wen{
		width: 92%;
		height: 13%;
		margin-top: 6px;
		display: flex;
		border: 1px solid #e9edf0;
		justify-content: space-between;
		padding: 10px;
	}
	.wen_imgs{
		width:60px;
		height: 60px;
	}
	.tianjia_wen{
		position: absolute;
		top: 10px;
		right: 260px;
		display: flex;
	}
</style>
